import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import AdsBrandBanner from '../AdsBrandBanner';
import { Section } from './styles';
import AdsBrandSellerInfo from './AdsBrandSellerInfo';
import AdsBrandProducts from './AdsBrandProducts';
var AdsBrandDesktop = function AdsBrandDesktop(_ref) {
  var _brand$content3, _brand$content4, _brand$content5, _brand$content6, _brand$content7;
  var adsPath = _ref.adsPath,
    brand = _ref.brand,
    handleBrandClick = _ref.handleBrandClick,
    handleBrandImpression = _ref.handleBrandImpression,
    handleProductClick = _ref.handleProductClick,
    handleProductView = _ref.handleProductView,
    marginTop = _ref.marginTop,
    isVideo = _ref.isVideo;
  var brandRedirectUrl = useMemo(function () {
    var _brand$content;
    if (!(brand == null ? void 0 : (_brand$content = brand.content) == null ? void 0 : _brand$content.redirectUrl)) return null;
    try {
      var _brand$content2;
      var url = new URL(brand == null ? void 0 : (_brand$content2 = brand.content) == null ? void 0 : _brand$content2.redirectUrl);
      url.searchParams.append('track_id', brand == null ? void 0 : brand.trackId);
      url.searchParams.append('internal_ad', 'true');
      return url.toString();
    } catch (error) {
      console.error('invalid URL', error);
      return null;
    }
  }, [brand]);
  var banner = {
    imageUrl: brand == null ? void 0 : (_brand$content3 = brand.content) == null ? void 0 : _brand$content3.imageUrl,
    redirectUrl: brandRedirectUrl
  };
  var inViewConfig = useMemo(function () {
    return {
      threshold: 0.5,
      triggerOnce: true
    };
  }, []);
  var _useInView = useInView(inViewConfig),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  useEffect(function () {
    if (inView) {
      handleBrandImpression();
    }
  }, [inView]);
  return brand && React.createElement(Section, {
    ref: ref,
    marginTop: marginTop,
    "data-testid": "ads-brand-desktop"
  }, React.createElement("span", {
    "data-testid": "ads-banner_screenshot",
    "ads-screenshot-id": "ads-banner_".concat(brand == null ? void 0 : brand.slot, "_").concat(brand == null ? void 0 : brand.campaignId)
  }), (brand == null ? void 0 : brand.template) === 'creative' && React.createElement(AdsBrandBanner, {
    adsPath: adsPath,
    banner: banner,
    isVideo: isVideo,
    handleBrandClick: handleBrandClick,
    width: 464,
    height: 289,
    styles: {
      borderBottomLeftRadius: 8,
      borderTopLeftRadius: 8
    }
  }), React.createElement(AdsBrandSellerInfo, {
    buttonTitle: brand == null ? void 0 : (_brand$content4 = brand.content) == null ? void 0 : _brand$content4.buttonTitle,
    handleBrandClick: handleBrandClick,
    redirectUrl: brandRedirectUrl,
    headline: brand == null ? void 0 : (_brand$content5 = brand.content) == null ? void 0 : _brand$content5.headline,
    logo: brand == null ? void 0 : (_brand$content6 = brand.content) == null ? void 0 : _brand$content6.logo,
    subtitle: brand == null ? void 0 : (_brand$content7 = brand.content) == null ? void 0 : _brand$content7.subtitle,
    template: brand == null ? void 0 : brand.template
  }), React.createElement(AdsBrandProducts, {
    campaignId: brand == null ? void 0 : brand.campaignId,
    products: brand == null ? void 0 : brand.products,
    template: brand == null ? void 0 : brand.template,
    handleProductClick: handleProductClick,
    handleProductView: handleProductView
  }));
};
AdsBrandDesktop.defaultProps = {
  adsPath: '',
  brand: {
    content: {
      buttonTitle: '',
      headline: '',
      imageUrl: '',
      logo: '',
      redirectUrl: '',
      subtitle: ''
    },
    products: [],
    template: '',
    trackId: ''
  },
  handleBrandClick: function handleBrandClick() {},
  handleBrandImpression: function handleBrandImpression() {},
  handleProductClick: function handleProductClick() {},
  handleProductView: function handleProductView() {},
  isVideo: false,
  marginTop: '0px'
};
process.env.NODE_ENV !== "production" ? AdsBrandDesktop.propTypes = {
  adsPath: PropTypes.string,
  brand: PropTypes.shape({
    campaignId: PropTypes.string,
    content: PropTypes.shape({
      buttonTitle: PropTypes.string,
      headline: PropTypes.string,
      imageUrl: PropTypes.string,
      logo: PropTypes.string,
      redirectUrl: PropTypes.string,
      subtitle: PropTypes.string
    }),
    products: PropTypes.arrayOf({}),
    slot: PropTypes.string,
    template: PropTypes.string,
    trackId: PropTypes.string
  }),
  handleBrandClick: PropTypes.func,
  handleBrandImpression: PropTypes.func,
  handleProductClick: PropTypes.func,
  handleProductView: PropTypes.func,
  isVideo: PropTypes.bool,
  marginTop: PropTypes.string
} : void 0;
AdsBrandDesktop.ssr = true;
export default AdsBrandDesktop;